import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Emoji from './Emoji';
import { EmojiPropTypes, getEmojiTitle } from '../../utils/emojis';

var EmojiPickerPreview =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(EmojiPickerPreview, _React$PureComponent);

  function EmojiPickerPreview() {
    _classCallCheck(this, EmojiPickerPreview);

    return _possibleConstructorReturn(this, _getPrototypeOf(EmojiPickerPreview).apply(this, arguments));
  }

  _createClass(EmojiPickerPreview, [{
    key: "getPlaceholderParams",
    value: function getPlaceholderParams() {
      return {
        title: 'Pick one',
        shortname: 'pick_them_all',
        emoji: this.props.placeholderEmoji
      };
    }
  }, {
    key: "getEmptyParams",
    value: function getEmptyParams() {
      return {
        title: 'No found',
        shortname: '404',
        emoji: this.props.notFoundEmoji
      };
    }
  }, {
    key: "getSelectedParams",
    value: function getSelectedParams() {
      var emoji = this.props.selectedEmoji;
      return {
        title: getEmojiTitle(emoji),
        shortname: emoji.id,
        emoji: this.props.selectedEmoji
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          index = _this$props.index,
          selectedEmoji = _this$props.selectedEmoji,
          onSelectEmoji = _this$props.onSelectEmoji,
          onClickEmoji = _this$props.onClickEmoji;

      var _ref = index === -1 ? this.getPlaceholderParams() : selectedEmoji ? this.getSelectedParams() : this.getEmptyParams(),
          title = _ref.title,
          emoji = _ref.emoji,
          shortname = _ref.shortname;

      return React.createElement("div", {
        className: classNames('flexbox flexbox-align-center flexbox-no-shrink', 'line-height-normal', 'border-top-small border-shade-50', 'padding-vertical-small padding-horizontal-small')
      }, React.createElement("div", {
        className: "flexbox-no-shrink margin-right-small"
      }, React.createElement(Emoji, {
        index: index,
        emoji: emoji,
        onSelect: onSelectEmoji,
        onClick: onClickEmoji
      })), React.createElement("div", {
        className: "flexbox-grow padding-right-small ellipsis"
      }, React.createElement("div", {
        className: "font-weight-semibold shade-05 ellipsis margin-bottom-smaller"
      }, title), React.createElement("div", {
        className: "shade-10 ellipsis"
      }, ":", shortname, ":")));
    }
  }]);

  return EmojiPickerPreview;
}(React.PureComponent);

_defineProperty(EmojiPickerPreview, "propTypes", {
  index: PropTypes.number.isRequired,
  notFoundEmoji: EmojiPropTypes.isRequired,
  placeholderEmoji: EmojiPropTypes.isRequired,
  selectedEmoji: EmojiPropTypes,
  onSelectEmoji: PropTypes.func.isRequired,
  onClickEmoji: PropTypes.func.isRequired
});

export default EmojiPickerPreview;